<template>
    <form method="POST" :action="route">
        <input type="hidden" name="_token" :value="token">
        <div class="col-8 mx-auto text-center pt-4">
            <p class="welcome-3 colortextmyfo1">Détails</p>
            <p class="welcome-3 colortextmyfo1">{{new Intl.NumberFormat().format(expected_floor_value)}} €</p>
        </div>
        <div class="form-group">
            <label for="target_return">Objectif minimum de rendement</label>
            <div class="invalid-feedback">
                Entrez votre objectif minimum de rendement.
            </div>
            <select class="form-control" id="target_return" name="target_return" v-model="floor_rate" @change="onDataChange">
                <option v-for="floor_rate in floor_rates" :key="floor_rate.id" :value="floor_rate.target_rate" >{{ floor_rate.target_rate*100 }} %</option>
            </select>

            <label for="target_date">Horizon de placement</label>
            <select class="form-control" id="target_date" name="target_date" v-model="target_date" @change="onDataChange">
                <option value="1">1 an</option>
                <option value="2">2 ans</option>
                <option value="3">3 ans</option>
                <option value="4">4 ans</option>
                <option value="5">5 ans</option>
                <option value="6">6 ans</option>
                <option value="7">7 ans</option>
                <option value="8">8 ans</option>
                <option value="9">9 ans</option>
                <option value="10">10 ans</option>
            </select>

            <label for="maximum_loss">Perte maximum tolérée</label>
            <select class="form-control" id="maximum_loss" name="maximum_loss">
                <option v-for="target_rate in target_rates" :key="target_rate.id" :value="target_rate.target_rate" >{{ target_rate.target_rate*100 }} %</option>
            </select>

            <div class="m-4 justify-content-center text-center">
                    <button type="submit" class="btn-alt-2 m-2 triggerspinner">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-clockwise mr-1" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"/>
                        <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z"/>
                    </svg>
                    Mettre en place cette stratégie
                </button>
            </div>
        </div>
    </form>
</template>

<script>
    export default {
        props: [
            'floor_rates',
            'target_rates',
            'sum_assets',
            'token',
            'route',
        ],

        data() {
            return {
                form: [],
                expected_floor_value: 0,
                floor_rate: 0.01,
                target_rate: 0.05,
                target_date: 1,
                valid: false,
            }
        },

        mounted() {
            this.onDataChange();


        },
        methods: {
            onDataChange(){
                // calcul ici data_av et data_ct en fonction de this.amount, this.time_horizon et this.performance

               /*  var labels = [];
                var data_av = [];
                var data_ct = []; */

                this.expected_floor_value = Math.round(this.sum_assets*Math.pow((1+parseFloat(this.floor_rate)),this.target_date));




                /* this.testGraph.data.labels = labels;
                this.testGraph.data.datasets[0].data = data_av;
                this.testGraph.data.datasets[1].data = data_ct;
                this.testGraph.update(); */
            },
        },
    }

</script>